import { useEffect, useRef } from "react";

// Downloads nothing until it's near the screen, then plays while visible and
// pauses off screen. Muted, looping, inline: same as every video on the site.
function LazyVideo({ src, ...props }) {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (video.getAttribute("src") !== src) video.src = src;
          video.play().catch(() => {}); // autoplay can be refused; the frame still shows
        } else {
          video.pause();
        }
      },
      { rootMargin: "600px 0px" } // start a little before it scrolls in
    );
    io.observe(video);
    return () => io.disconnect();
  }, [src]);

  return <video ref={ref} muted loop playsInline preload="none" {...props} />;
}

export default LazyVideo;
